import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { createContext, useContext } from "react";
import axios from "axios";
import sift from "sift";
import { sort } from "sift-sort";
import createPersistedState from "use-persisted-state";
import { useRematchReducer } from "use-rematch-reducer";
import useApi from "../../api";
import config from "../../config";
import UserMenu from "./UserMenu";

var isUserMenuEnabled = config.userCustomisationMenu.get("enabled"),
    useLocalState = createPersistedState("traffic-app_user-menu"),
    UserMenuContext = createContext(),
    INITIAL_STATE = {
  recentlyViewed: [],
  recentSearches: [],
  compare: []
},
    useUserMenuStore = function useUserMenuStore() {
  var a = useLocalState(INITIAL_STATE),
      b = _slicedToArray(a, 2),
      c = b[0],
      d = b[1],
      e = function e(a) {
    return d(a), a;
  },
      f = useApi(),
      g = function g(a) {
    var b = null;

    switch (a.propertyType) {
      case "house":
      case "townhome":
        b = f.packages.retrieve(a.slug);
        break;

      case "land":
        b = f.lots.retrieve(a.slug);
        break;

      default:
    }

    var c = a.flags || {},
        d = c.custom;
    return _objectSpread({}, a, {}, b || {}, {
      similar: null,
      unavailable: !b,
      flags: _objectSpread({}, c, {
        custom: b ? "Unavailable" === d && b ? "" : d : "Unavailable"
      })
    });
  },
      h = c.compare.map(g);

  c.compare = h;
  var i = c.recentlyViewed.map(g);
  return c.recentlyViewed = i, {
    name: "user-menu-store",
    state: _objectSpread({}, INITIAL_STATE, {}, c, {
      show: !1,
      active: null
    }),
    reducers: {
      toggle: function toggle(a, b) {
        var c = "boolean" == typeof b,
            d = c ? b : !a.show,
            e = a.active;
        return !c && b && e !== b && (e = b, d = !0), _objectSpread({}, a, {
          show: d,
          active: e
        });
      },
      addRecentlyViewed: function addRecentlyViewed(a, b) {
        var c = "land" === b.propertyType,
            d = c ? a.recentlyViewed.find(sift({
          slug: b.slug
        })) : a.recentlyViewed.find(sift({
          id: b.id
        })),
            f = b && !d ? [b].concat(_toConsumableArray(a.recentlyViewed)) : a.recentlyViewed;
        b && !d && (f = f.map(function (a) {
          return _objectSpread({}, a, {
            similar: null
          });
        })), 4 <= f.length && (f.length = 4);
        var g = f ? _objectSpread({}, a, {
          recentlyViewed: f
        }) : a,
            h = config.api.get("view_count.key"),
            i = config.api.get("view_count.update_url");
        return !c && b.id && h && i && !d && axios.post(i, {
          package_id: b.id,
          api_key: h
        }).catch(console.log), e(g);
      },
      addRecentSearch: function addRecentSearch(a, b) {
        var c = b ? _objectSpread({}, a, {
          recentSearches: [].concat(_toConsumableArray(a.recentSearches), [b])
        }) : a;
        return e(c);
      },
      addCompare: function addCompare(a, b) {
        var c = a.compare.find(sift({
          slug: b.slug
        })),
            d = b && !c ? [].concat(_toConsumableArray(a.compare), [b]) : a.compare;
        25 <= d.length && (d.length = 25);
        var f = b ? _objectSpread({}, a, {
          compare: sort(d, {
            propertyType: 1
          }),
          active: "compare",
          show: !0
        }) : a;
        return e(f);
      },
      removeCompare: function removeCompare(a, b) {
        var c = b ? a.compare.filter(function (a) {
          return a.slug !== b;
        }) : null,
            d = b ? _objectSpread({}, a, {
          compare: sort(c, {
            propertyType: 1
          })
        }) : a;
        return e(d);
      }
    }
  };
};

export var UserMenuProvider = function UserMenuProvider(a) {
  var b = a.disableMenu,
      c = a.children,
      d = useUserMenuStore(),
      e = useRematchReducer(d),
      f = _slicedToArray(e, 2),
      g = f[0],
      h = f[1];

  return /*#__PURE__*/React.createElement(UserMenuContext.Provider, {
    value: [g, h]
  }, c, !b && isUserMenuEnabled ? /*#__PURE__*/React.createElement(UserMenu, null) : null);
};
export var withUserMenu = function withUserMenu(a) {
  return function (b) {
    var c = useContext(UserMenuContext),
        d = _slicedToArray(c, 2),
        e = d[0],
        f = d[1];

    return /*#__PURE__*/React.createElement(a, Object.assign({}, b, {
      userMenu: [e, f]
    }));
  };
};
export default withUserMenu;